<template>
  <div class="business-category-container">
    <h1 class="main-title">经营类目</h1>

    <div class="category-list">
      <div
        v-for="(item, index) in categoryList"
        :key="index"
        class="category-item"
      >
        {{ item }}
      </div>
    </div>

    <div class="footer-tip">
      细分类目逐步开通中，诚邀各位入驻~
    </div>
  </div>
</template>

<script>
export default {
  name: "BusinessCategory",
  data() {
    return {
      categoryList: [
        "手表配饰",
        "个人洗护",
        "医药健康",
        "宠物",
        "母婴",
        "服装鞋靴",
        "家居生活",
        "生鲜",
        "生活服务",
        "运动户外",
        "美容彩妆",
        "数码家电",
        "汽车用品",
        "环球美食",
        "箱包"
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.business-category-container {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  padding: 40px 60px;
  background-color: #ffffff;
  color: #262626;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  text-align: left;

  .main-title {
    margin: 0 0 28px 0;
    font-size: 26px;
    font-weight: 700;
    color: #1f1f1f;
    line-height: 1.3;
  }

  .category-list {
    margin-bottom: 40px;

    .category-item {
      font-size: 14px;
      line-height: 2.2;
      color: #262626;
    }
  }

  .footer-tip {
    font-size: 14px;
    color: #595959;
    line-height: 1.6;
  }
}

@media only screen and (max-width: 768px) {
  .business-category-container {
    padding: 24px 16px;

    .main-title {
      font-size: 22px;
      margin-bottom: 20px;
    }

    .category-list {
      margin-bottom: 30px;

      .category-item {
        font-size: 14px;
        line-height: 2;
      }
    }
  }
}
</style>
